import { useState, useCallback, useEffect, useMemo } from 'react';
import { SelectItemProps } from '@ui/src';
import { Account } from '../../../types/account';
import { useLazyGetTransactionsAccountByIdQuery } from '../services';

const useGetAccountById = (fullNumber?: string) => {
  const [account, setAccount] = useState<Account>();

  const [getDataById, { isFetching, isLoading }] =
    useLazyGetTransactionsAccountByIdQuery();

  const getDataByIdAction = useCallback(async () => {
    if (fullNumber) {
      const response = await getDataById(fullNumber);

      if (response?.data?.data) {
        setAccount(response.data.data);
      }
    }
  }, [fullNumber]);

  useEffect(() => {
    getDataByIdAction();
  }, [getDataByIdAction]);

  const partner = useMemo(() => {
    let res;

    if (account) {
      res = account.pspAccount?.pspPartner;
    }
    return res;
  }, [account]);

  return {
    getDataByIdAction,
    account,
    list: account
      ? ([
          {
            name: account?.description,
            description: '',
            value: account?.fullNumber,
            suffix: account?.fullNumber,
          },
        ] as SelectItemProps[])
      : [],
    isLoading: isLoading || isFetching,
    setAccount,
    pspPartnersList: partner
      ? ([
          {
            name: partner.companyName,
            value: partner.id,
          },
        ] as SelectItemProps[])
      : [],
  };
};

export default useGetAccountById;
